import { useEffect } from 'react';

const MOBILE_WIDTH_THRESHOLD = 768
export const KEYBOARD_VISIBILITY_THRESHOLD = 150
export enum KEYBOARD_VISIBILITY {
  HIDDEN = 'hidden',
  VISIBLE = 'visible',
}
export type KeyboardVisibility = KEYBOARD_VISIBILITY.HIDDEN | KEYBOARD_VISIBILITY.VISIBLE

const useVirtualKeyboard = (action: (visibility: KeyboardVisibility) => void, event = 'resize'): void => {
  useEffect(() => {
    const vv = window?.visualViewport
    const isVisualViewportSupported = vv && vv?.height > 0
    const initialVisualViewport = {
      height: isVisualViewportSupported ? vv?.height ?? 0 : 0,
      width: isVisualViewportSupported ? vv?.width ?? 0 : 0,
    }
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    const isMobile = (navigator as any)?.userAgentData?.mobile || initialVisualViewport.width < MOBILE_WIDTH_THRESHOLD

    const onChange = () => {
      const newVisualViewport = {
        height: vv?.height ?? 0,
        width: vv?.width ?? 0,
      }
      if (
        initialVisualViewport.width === newVisualViewport.width &&
        initialVisualViewport.height - newVisualViewport.height > KEYBOARD_VISIBILITY_THRESHOLD
      ) {
        return action(KEYBOARD_VISIBILITY.VISIBLE)
      }
      return action(KEYBOARD_VISIBILITY.HIDDEN)
    }
    if (isVisualViewportSupported && isMobile) {
      vv.addEventListener(event, onChange)
    }

    return (): void => {
      if (isVisualViewportSupported && isMobile) {
        vv.removeEventListener(event, onChange)
      }
    };
  }, [action, event]);
};

export default useVirtualKeyboard;
